import React from 'react';
import PostPreviewLayoutMC from './PostPreviewLayoutMC';

/**
 * Preview for TikTok comment posts. The video metadata is consumed from the
 * microservice via `conversation.platformSpecificData` (snake_case keys:
 * video_thumbnail_url, video_share_url, video_caption, display_name, username)
 * and is enriched asynchronously, so the card degrades gracefully while the
 * video data is still missing.
 *
 * @component TikTokPostPreviewMC
 * @param {Object} props - Component properties
 * @param {Object} props.conversation - The conversation object containing platform and post info.
 * @returns {JSX.Element|null} The rendered preview, or null while there is nothing to show yet.
 */
const TikTokPostPreviewMC = ({ conversation }) => {
  const data = conversation?.platformSpecificData || {};
  const thumbnailUrl = data.video_thumbnail_url;
  const shareUrl = data.video_share_url;
  const caption = data.video_caption;
  const creator = data.display_name || data.username;

  // El video se enriquece de forma asíncrona; no renderizar hasta tener algo que mostrar.
  if (!thumbnailUrl && !caption) return null;

  return (
    <PostPreviewLayoutMC originalPostUrl={shareUrl}>
      {thumbnailUrl && (
        <a
          href={shareUrl || '#'}
          target="_blank"
          rel="noopener noreferrer"
          className="tw-group tw-relative tw-block tw-w-full tw-aspect-[9/16] tw-max-h-[400px] tw-overflow-hidden tw-rounded-lg tw-bg-black"
        >
          <img
            src={thumbnailUrl}
            alt={caption || creator || 'TikTok'}
            className="tw-w-full tw-h-full tw-object-cover"
          />
          <div className="tw-absolute tw-inset-0 tw-flex tw-items-center tw-justify-center tw-bg-[rgba(0,0,0,0.3)] tw-opacity-0 group-hover:tw-opacity-100 tw-transition-opacity tw-duration-200">
            <svg
              className="tw-w-12 tw-h-12 tw-text-white"
              viewBox="0 0 24 24"
              fill="currentColor"
              aria-hidden="true"
            >
              <path d="M8 5v14l11-7z" />
            </svg>
          </div>
        </a>
      )}
      {creator && (
        <span className="tw-mt-2 tw-text-sm tw-font-semibold tw-text-gray-900">
          {creator}
        </span>
      )}
      {caption && (
        <p className="tw-mt-1 tw-text-xs tw-text-gray-600 tw-line-clamp-3">
          {caption}
        </p>
      )}
    </PostPreviewLayoutMC>
  );
};

export default TikTokPostPreviewMC;
